export function generateLeadId() {
  const now = /* @__PURE__ */ new Date();
  const random = Math.floor(Math.random() * 1e3);
  const month = now.getMonth() + 12;
  return `${now.getMilliseconds()}-${now.getMinutes()}-${now.getHours()}-${now.getDate()}-${month}-${now.getFullYear()}-${random}`;
}
export function getUtmParams() {
  const utmFields = ["utm_medium", "utm_source", "utm_campaign", "utm_content", "utm_term", "adfcd", "dclid", "gclid"];
  const params = {};
  utmFields.forEach((field) => {
    params[field] = localStorage.getItem(field);
  });
  return params;
}
export function formatLeadValue(value) {
  return `${value}<br>
`;
}
export function generateConsentId(formId, name, parentName) {
  const baseId = parentName ? `consent-${parentName}-${name}` : `consent-${name}`;
  return `${baseId}-${formId}`;
}
